import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ManifestProvider } from './context/ManifestContext';
import { McpRegistryProvider } from './context/McpRegistryContext';
import { StarsProvider } from './context/StarsContext';
import { UserProvider } from './context/UserContext';
import Layout from './components/Layout';
import MarketplacePage from './pages/MarketplacePage';
import SkillDetailPage from './pages/SkillDetailPage';
import McpDetailPage from './pages/McpDetailPage';
import CreateSkillPage from './pages/CreateSkillPage';
import './App.css';
import { StylesProvider, ToastProvider } from '@caos/ca-component-library';

function App() {
  return (
    <StylesProvider>
      <ToastProvider position="bottom-right" defaultDuration={3000}>
        <BrowserRouter>
          <UserProvider>
          <ManifestProvider>
            <McpRegistryProvider>
              <StarsProvider>
              <Layout>
                <Routes>
                  <Route path="/" element={<MarketplacePage />} />
                  <Route path="/skills/:id" element={<SkillDetailPage />} />
                  <Route path="/mcp/:id" element={<McpDetailPage />} />
                  <Route path="/create-skill" element={<CreateSkillPage />} />
                </Routes>
              </Layout>
              </StarsProvider>
            </McpRegistryProvider>
          </ManifestProvider>
          </UserProvider>
        </BrowserRouter>
      </ToastProvider>
    </StylesProvider>
  );
}

export default App;
